import { render, staticRenderFns } from "./ConversationsList.vue?vue&type=template&id=47483d10&scoped=true&"
import script from "@/scripts/conversations/conversationList.js?vue&type=script&lang=js&"
export * from "@/scripts/conversations/conversationList.js?vue&type=script&lang=js&"
import style0 from "./ConversationsList.vue?vue&type=style&index=0&id=47483d10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47483d10",
  null
  
)

export default component.exports